import { WeaLocaleProvider } from 'ecCom';
import { observable, action, computed } from 'mobx';
const getLabel = WeaLocaleProvider.getLabel;
import * as API from '../../apis/gantt';
import { message,Modal } from 'antd';
import { WeaForm } from 'comsMobx';
import { getContentPath } from '../../util/contentPath';
import { isFromProtal } from '../../util/cubeUtil';
import $ from 'jquery';
import _ from 'lodash';
import window_ from '../../util';
import { spellResourceCondition,unSpellResourceCondition,getDefaultValueSpan,getReConditionObj } from '../../util/cubeUtil';
declare var GanttMaster;
declare var React;
declare var ReactDOM;
declare var ecCom;
declare var Task;

export default class GanttStore {
    @observable loading: boolean = false;
    @observable loadingtip:string='';
    @observable isInit: boolean = false;
    @observable id: string;
    @observable previousId: string;
    @observable deletevisible: boolean=false;
    currentDeleteId:string='';
    @observable rootId: string;  //默认根节点
    resourceId:any='';  //关联字段
    @observable timelinekey: string;//时间轴选项
    @observable datas: any={};//数据原始值
    @observable fields: any = [];
    @observable taskInfo={show:false,id:'',left:'0px',top:'0px',text1:'',text2:''};
    @observable litterTool={show:false,id:'',top:'0px',canRead:false,canWrite:false,canDelete:false};
    taskOutFun;//任务左侧按钮鼠标移出相关方法
    /**
     *弹框卡片页相关属性 
     */
    @observable cardDiag_visible = false;
    @observable cardDiag_url = "";
    @observable baseInfo;//甘特图基本信息
    canCreate=false;
    canSave=false;
    isSuperiorFieldSet=false;
    /**
     * 给插件用的临时属性,是否正在拖动svg任务条
     */
    ganttIsMouseDown=false;
    ganttMaster;
    /**表格编辑用 */
    optionsMap={};
    browserMap={};
    /**相关字段未显示出来的情况，临时存储，保存时使用 */
    otherModifiedDatas={};
    /**查询条件相关 */
    @observable form = new WeaForm();
    @observable conditionInfo: any = [];
    /**gridEditor是否在拖动中 */
    isGridDragging=false;
    @observable colorDatas: any = [];
    datasColorMap:any={};
    @observable toDelIds: any=[];
    @observable windowTitle: string = '';

    @action
    init = () => {
        this.form = new WeaForm();
        this.initMessage();
        this.loading=true;
        API.getGanttDatas({ id: this.id, rootId: this.rootId,resourceId:this.resourceId }).then(action(({ error, status, baseInfo, datas, fieldsList,canCreate,canSave,timelineKey,isSuperiorFieldSet,optionsMap,browserMap,dataIndex,datasColorMap,noRight }) => {
            if (status == '1') {
                if(noRight){
                    window_.weaHistory.push('/main/cube/encrypt');
                    return;
                }
                if(!isFromProtal()){
                    this.windowTitle = baseInfo&&baseInfo.ganttname;
                }
                this.getConditionInfo();
                this.fields=fieldsList;
                this.datasColorMap=datasColorMap;
                this.canCreate=canCreate;
                this.canSave=canSave;
                /**当用户在前端更改时间轴选项之后，不刷新此数据 */
                // if((this.previousId != undefined && this.previousId != this.id) || (!this.timelinekey && this.timelinekey.length == 1)){
                if(!this.previousId || (this.previousId != undefined && this.previousId != this.id) || (this.timelinekey && _.inRange(Number(this.timelinekey),0,4))){
                    switch (timelineKey) {
                        case '1':
                            timelineKey='2w'
                            break;
                        case '2':
                            timelineKey='1y'
                            break;
                        case '3':
                            timelineKey='2Q'
                            break;
                        case '4':
                            timelineKey='2y'
                            break;
                        default:
                            timelineKey='1M'
                            break;
                    }
                    this.timelinekey=timelineKey;
                }
                this.isSuperiorFieldSet=isSuperiorFieldSet;
                this.baseInfo=baseInfo;
                // if (this.resourceId!="" && location.href.indexOf('&resourceid=')==-1) {
                if (this.baseInfo.reffield!="" && location.href.indexOf('&resourceid=')==-1) {
                    this.loading = false;
                    this.isInit = true;
                    error = '甘特图设置了数据关联字段，需要传递resourceid参数';
                    message.error(error, 10);
                    // throw new Error(error);
                }
                this.optionsMap=optionsMap;
                this.browserMap=browserMap;
                this.loadDatas(datas,dataIndex);
            } else {
                message.error(error);
                throw error;
            }
        }));

        API.getColors({ ganttid:this.id }).then(({ error, status, datas}) => {
            if (status == '1') {
                this.colorDatas=datas;
            } else {
                message.error(error);
                throw error;
            }
        })
    }

    @action
    loadDatas=(datas,dataIndex)=>{
        const _this=this;
        this.datas={};//初始化原始的值
        this.toDelIds=[];
        datas.forEach(ele => {
            this.datas[ele.id]=ele;//保存初始状态数据
            ele.depends=dataIndex[ele.front];//前置关系赋值
        });
        if(datas.length==0){
            this.afterInit();
        }
        setTimeout(()=>{
            _this.clear();
            _this.ganttMaster = new GanttMaster(_this);
            _this.ganttMaster.init($(`#workSpace_${this.getGanttId}`));
            $(`#workSpace_${this.getGanttId}`).click(e=>{_this.workSpaceClick(e)});
            _this.ganttMaster.loadProject({ tasks: datas, selectedRow: 0});
            //设置时间轴选项
            let str = 'zoomChange' + _this.timelinekey;
            $(`#workSpace_${this.getGanttId}`).trigger(str);
            this.loading = false;

            //左侧菜单点击回调
            let leftMenuSwitchDom = $("#portal-intro2");            
            leftMenuSwitchDom && $('#portal-intro2').bind('click',()=>{
                setTimeout(() => {
                    // _this.ganttMaster.splitter.resize(50, 300);
                    _this.ganttMaster.splitter.resize();
                }, 60);
            })
        },50);
    }

    /**
     * 初始化查询条件
     */
    @action
    getConditionInfo = () => {
        this.loading = true;
        API.getConditionInfo({ ganttid:this.id }).then(({ error, status, conditionInfo}) => {
            if (status == '1') {
                this.conditionInfo = conditionInfo;
                this.form.initFormFields(conditionInfo);
                this.form.isFormInit = true;
            } else {
                message.error(error);
                throw error;
            }
            this.loading = false;
        })
    }

    /**
     * 查询
     */
    @action
    doSearch = () => {
        var _this=this;
        var modified=this.getSaveDatas();
        if(!$.isEmptyObject(modified)){
            Modal.confirm({
                title: '当前存在未保存的数据，搜索将清理掉修改，确定搜索？',
                okText: getLabel(382958, '确定'),
                okType: 'danger',
                cancelText: getLabel(201, "取消"),
                onOk() {
                    _this.doSearchSubmit();
                }
            });
        }else{
            this.doSearchSubmit();
        }
    }

    @action
    doSearchSubmit = () => {
        this.loading = true;
        API.doSearchDatas({ganttid: this.id, rootId: this.rootId,resourceId:this.resourceId,  ...this.form.getFormParams()}).then(({ error, status,datas,dataIndex}) => {
            if (status == '1') {
                this.clear();
                this.otherModifiedDatas={};
                this.loadDatas(datas,dataIndex);
            } else {
                message.error(error);
                throw error;
            }
            this.loading = false;
        })
    }

    /**
     * 卡片保存后的回调
     */
    @action
    cardSaveFun=()=>{
        this.cardDiag_visible=false;
        this.loading=true;
        API.getGanttDatas({ id: this.id, rootId: this.rootId,resourceId:this.resourceId}).then(action(({error, status, baseInfo, datas, fieldsList,canCreate,canSave,isSuperiorFieldSet,optionsMap,browserMap,dataIndex,datasColorMap  }) => {
            if (status == '1') {
                this.clear();                
                this.fields=fieldsList;
                this.datasColorMap=datasColorMap;
                this.canCreate=canCreate;
                this.canSave=canSave;
                this.isSuperiorFieldSet=isSuperiorFieldSet;
                this.baseInfo=baseInfo;
                this.optionsMap=optionsMap;
                this.browserMap=browserMap;
                this.otherModifiedDatas={};
                this.loadDatas(datas,dataIndex);
            } else {
                message.error(error);
                throw error;
            }
        }));
    }



    initMessage = () => {
        GanttMaster.messages.CANNOT_WRITE = getLabel("130195", "不能编辑");
        GanttMaster.messages.CHANGE_OUT_OF_SCOPE = getLabel("130196", "超出编辑范围更新父任务");
        GanttMaster.messages.START_IS_MILESTONE = getLabel("130197", "开始是里程碑");
        GanttMaster.messages.END_IS_MILESTONE = getLabel("130198", "结束是里程碑");
        GanttMaster.messages.TASK_HAS_CONSTRAINTS = getLabel("130199", "任务包含约束");
        GanttMaster.messages.GANTT_ERROR_DEPENDS_ON_OPEN_TASK = getLabel("130200", "特定于开放的任务");
        GanttMaster.messages.GANTT_ERROR_DESCENDANT_OF_CLOSED_TASK = getLabel("130201", "衍生于关闭的任务");
        GanttMaster.messages.TASK_HAS_EXTERNAL_DEPS = getLabel("130202", "任务包含外部依赖");
        GanttMaster.messages.GANTT_ERROR_LOADING_DATA_TASK_REMOVED = getLabel("130203", "加载被删除的任务");
        GanttMaster.messages.ERROR_SETTING_DATES = getLabel("130204", "日期时间设置错误（依赖时间关系或父级任务工期）");
        GanttMaster.messages.CIRCULAR_REFERENCE = getLabel("130205", "有无限循环参照");
        GanttMaster.messages.CANNOT_DEPENDS_ON_ANCESTORS = getLabel("130206", "不能依赖父级任务");
        GanttMaster.messages.CANNOT_DEPENDS_ON_DESCENDANTS = getLabel("130207", "不能依赖子级任务");
        GanttMaster.messages.INVALID_DATE_FORMAT = getLabel("130208", "无效日期格式");
        GanttMaster.messages.TASK_MOVE_INCONSISTENT_LEVEL = getLabel("130209", "任务移动非连续级别");
        GanttMaster.messages.GANTT_QUARTER = getLabel("17495", "季度");
        GanttMaster.messages.GANTT_MONTH = getLabel("6076", "月");
        GanttMaster.messages.GANTT_SEMESTER = getLabel("20729", "半年");
        GanttMaster.messages.GANTT_UPON = getLabel("31276", "上");
        GanttMaster.messages.GANTT_DOWN = getLabel("23010", "下");
        GanttMaster.messages.GANTT_DI = getLabel("15323", "第");
        GanttMaster.messages.GANTT_WEEK_SHORT = getLabel("1926", "周");
        GanttMaster.messages.Message1 = getLabel("130210", "结束日期必须大于开始日期");
        GanttMaster.messages.Message2 = getLabel("130211", "结束时间必须大于开始时间");
        GanttMaster.messages.Message3 = getLabel("130212","父任务开始日期不能晚于子任务的开始日期");
        GanttMaster.messages.Message4 = getLabel("130213", "父任务结束日期不能早于子任务结束日期");
        GanttMaster.messages.Message5 = getLabel("130214","父任务开始时间不能晚于子任务的开始时间");
        GanttMaster.messages.Message6 = getLabel("130215", "父任务结束时间不能早于子任务结束时间");
    }



    getTaskRowHtmlTemplate = (task) => {
        let tr= `<tr id="tid_${task.id}" canWrite="${task.canWrite}" data-taskid="${task.id}" class="taskEditRow ${task.isParent() ? 'isParent' : ''} ${task.collapsed ? 'collapsed' : ''}" data-level="${task.level}">
        <td class="gdfCell">${task.getRow()+1}</td>`;
        this.fields.forEach(item=>{
            if(item.systemFlag&&item.systemFlag==1){
                tr+=`<td class="gdfCell indentCell" fieldLink="${item.fieldLink}">
                        <div class="exp-controller" data-align="center"></div>
                        <span>${task[item.fieldLink] ? task[item.fieldLink] : ''}</span>
                    </td>`;
            }else{
                let val=task[item.fieldLink] ? task[item.fieldLink] : '';
                if(item.fieldhtmltype=='4'){//check框
                    if(val=='1'){
                        val='是';
                    }else if(val=='0'){
                        val='否';
                    }
                }
                tr+=`<td class="gdfCell" fieldLink="${item.fieldLink}">
                        <span>${val}</span>
                    </td>`;
            }
        });
        tr+='</tr>';
        return tr;
    }

    getTaskEmptyRowHtmlTemplate = () => {
        let tr= `<tr class="taskEditRow emptyRow" ><td class="gdfCell"></td>`;
        this.fields.forEach(item=>{
            tr+=`<td class="gdfCell"></td>`;
        });
        tr+='</tr>';
        return tr;
    }

    @action
    addTaskRow=(taskid,type)=>{//above 上级  sibling 兄弟级  below 下级
        var task=this.ganttMaster.getTask(taskid);
        var superiorFieldTd=task.rowElement.find('td[fieldLink="field'+this.baseInfo.superiorField+'"]')[0];//用来判断上级字段是否显示
        var newTaskId="tmp" + new Date().getTime();
        var superior='';//新task的上级span
        var superior_value='';//新task的上级value
        var row = task.getRow();
        var level=task.level;
        if(type=='above'){
            if(task['field'+this.baseInfo.superiorField+"_value"]){
                var superTask=this.ganttMaster.getTask(task['field'+this.baseInfo.superiorField+"_value"]);
                superior=superTask.name;
                superior_value=superTask.id;
            }
            //当前级及所有下级往下移一级
            var allToRefresh=task.getAllChildren();
            allToRefresh.splice(0,0,task);
            allToRefresh.forEach(element => {
                element.level+=1;
                this.ganttMaster.editor.refreshTaskRow(element);
            });
            //如果添加的是上级，则当前级的上级字段都要变更
            task['field'+this.baseInfo.superiorField]='';
            task['field'+this.baseInfo.superiorField+'_value']=newTaskId;
            this.modifyTd(superiorFieldTd,newTaskId,this.baseInfo.superiorField,task);
            // this.litterTool.id = newTaskId;
            //更新操作栏
            this.taskOutFun&&this.taskOutFun();
            // console.log('id', this.litterTool.id);
        }else if(type=='sibling'){
            superior=task['field'+this.baseInfo.superiorField];
            superior_value=task['field'+this.baseInfo.superiorField+"_value"];
            var allChildrens=task.getAllChildren();
            if(allChildrens.length>0){
                row=allChildrens[allChildrens.length-1].getRow()+1;
            }else{
                row+=1;
            }
        }else if(type=='below'){
            superior=task.name;
            superior_value=task.id;
            var allChildrens=task.getAllChildren();
            if(allChildrens.length>0){
                row=allChildrens[allChildrens.length-1].getRow()+1;
            }else{
                row+=1;
                task.rowElement.addClass("isParent");
            }
            level+=1;
        }
        var newTask=new Task(newTaskId, "", "", level, "", "", "", "");
        if(superiorFieldTd){
            newTask['field'+this.baseInfo.superiorField]=superior;
            newTask['field'+this.baseInfo.superiorField+'_value']=superior_value;
        }
        this.ganttMaster.addTask(newTask, row,'addNew');
        this.ganttMaster.editor.refreshTaskRow(newTask);

        //如果上级字段存在则给上级字段赋值(newTask)
        var newSuperiorFieldTd=newTask.rowElement.find('td[fieldLink="field'+this.baseInfo.superiorField+'"]')[0];
        if(superior_value){
            this.modifyTd(newSuperiorFieldTd,superior_value,this.baseInfo.superiorField,newTask,superior);
        }

        //新增的数据处于编辑状态
        this.editTaskRow(newTask.rowElement,newTask);
    }

    clear=()=>{}//index.tsx didMount时赋值，作用：清除ganttContainer组件

    getSaveDatas=()=>{
        var modified:any={};
        $('sup[info]').each((index,item)=>{
            var info=item.getAttribute('info').replace('_value','');
            var infos=info.split('_');
            var id=infos[0];
            var field=infos[1];
            let task=this.ganttMaster.getTask(id);
            var value=task[field+'_value']||task[field]||'';
            modified[info]=value;
        })
        modified={...modified,...this.otherModifiedDatas};
        return modified;
    }

    @action
    save=()=>{
        let conditions = this.form.getFormParams();

        var modified=this.getSaveDatas();
        if($.isEmptyObject(modified)&&this.toDelIds.length===0){
            message.warn('未做任何修改！');
            return;
        }

        let newids='';
        this.ganttMaster.tasks.forEach(item=>{
            if(item.id.startsWith('tmp')){
                newids+=item.id+',';
            }
        });
        if(newids.endsWith(',')){
            newids=newids.substring(0,newids.length-1);
        }
        this.loading=true;
        this.isInit=false;
        //删除待删除的任务（type 0：不删除子级）
        this.toDelIds.forEach(id => {
            if (id && !id.startsWith('tmp')) {
                API.deleteDatas({ ganttid:this.id,billid: id,type: 0}).then(action(({ error, status,errorCode}) => {
                    if (status == '1') {
                        if(errorCode=='-1'){
                            message.error(error);
                        }else{
                            //message.success(getLabel(83472, "删除成功！"));
                            this.clear();
                            this.init();
                        }
                        this.deletevisible=false;
                        this.loading=false;
                    } else {
                        message.error(error);
                        throw error;
                    }
                }));
            }
            
        });
        //保存修改的内容
        API.save({ ganttid:this.id,newids:newids,modified:JSON.stringify(modified)}).then(action(({ error, status,errorCode}) => {
            if (status == '1') {
                if(errorCode=='-1'){
                    message.error(error);
                }else{
                    message.success(getLabel(18758, "保存成功。"));
                }
                this.deletevisible = false;
                this.loading=false;
            } else {
                message.error(error);
                throw error;
            }
            this.clear();
            this.otherModifiedDatas={};
            
            //保存后，保留高级搜索的条件
            this.form.updateFields(conditions);
            if(_.values(conditions).some(v=>v!='')){
                this.doSearch();
            }else{
                this.init();
            }
        }));
        
    }


    //未保存的数据删除
    @action
    deleteTmpTaskRow=(id)=>{
        this.deletevisible = true;
        this.currentDeleteId = id;
        // this.ganttMaster.getTask(id).deleteTask();
        // var workspace=$(`.TWGanttWorkSpace_${this.id}`);
        // var gridGroup= workspace.find("#gridGroup").get(0);
        // $(gridGroup).find('rect[class="ganttSVGOverRow"]').attr('class','ganttLinesSVG');
        // this.litterTool.show=false;
    }


    //删除行 type:1 且删除子级   0：不删除子级
    @action
    deleteTaskRow=(type)=>{
        this.toDelIds = [];
        let tasks = this.ganttMaster.tasks;

        //获取待删任务
        let task = this.ganttMaster.getTask(this.currentDeleteId);
        
        this.loading=true;
        //当前任务上级任务赋给子任务上级任务
        this.ganttMaster.tasks.forEach(element => {
            if(element['field'+this.baseInfo.superiorField+'_value']==this.currentDeleteId){
                let current_superiorFieldTd=element.rowElement.find('td[fieldLink="field'+this.baseInfo.superiorField+'"]')[0];
                if(current_superiorFieldTd){
                    // $(current_superiorFieldTd).find('span')[0].innerText="";
                    // element['field'+this.baseInfo.superiorField]="";
                    $(current_superiorFieldTd).find('span')[0].innerText = task.rowElement.find('td[fieldLink="field'+this.baseInfo.superiorField+'"]')[0].innerText;
                    element['field'+this.baseInfo.superiorField]=task['field'+this.baseInfo.superiorField];
                    
                    let newSuperiorFieldTd = task.rowElement.find('td[fieldLink="field'+this.baseInfo.superiorField+'"]')[0];
                    //task上级任务
                    let superiorId = task['field'+this.baseInfo.superiorField+'_value']
                    let superiorName = task['field'+this.baseInfo.superiorField]
                    if(superiorId){
                        this.modifyTd(newSuperiorFieldTd,superiorId,this.baseInfo.superiorField,element,superiorName);
                    }

                    //新增的数据处于编辑状态
                    // this.editTaskRow(element.rowElement,newTask);
                }
            }
        });

        //当前删除任务为未保存的任务
        if (this.currentDeleteId.startsWith('tmp')) { //当前删除任务为未保存任务，且删除子任务
            if(type==1){
                task.getAllChildren().forEach(element => {
                    // this.currentDeleteId = element.id;
                    element.deleteTask();
                    if (this.ganttMaster.getTask(element.id)) {
                        this.ganttMaster.tasks.splice(tasks.findIndex(item => item.id == element.id), 1);
                    }
                    this.toDelIds.push(element.id);
                    // this.deleteTaskRow(1);
                });
                var workspace=$(`.TWGanttWorkSpace_${this.id}`);
                var gridGroup= workspace.find("#gridGroup").get(0);
                $(gridGroup).find('rect[class="ganttSVGOverRow"]').attr('class','ganttLinesSVG');
                this.litterTool.show=false;
            }else if (type==0) { //当前删除任务为未保存任务，且不删除子任务
                //重新计算名称列的padding-left
                let allToRefresh=task.getAllChildren();
                allToRefresh.splice(0,0,task);
                allToRefresh.forEach(element => {
                    element.level-=1;
                    this.ganttMaster.editor.refreshTaskRow(element);
                });
                //task.deleteTask();
            }
            //删除当前任务
            task.deleteTask();
            if (this.ganttMaster.getTask(this.currentDeleteId)) {
                this.ganttMaster.tasks.splice(tasks.findIndex(item => item.id == this.currentDeleteId), 1);
            }
            this.loading=false;
            this.deletevisible=false;
            //更新上级任务父任务标识
            let supId = task['field'+this.baseInfo.superiorField+'_value']
            let supDomId = "#tid_"+supId;
            tasks.forEach(item =>{
                if (item.id==supId && item.getAllChildren().length==0) {
                //清除父任务标识
                $(supDomId).attr('class',$(supDomId).attr('class').replace(/isParent/,''))
                }
            })
            return;
        }

        //更新上级任务父任务标识
        let supId = task['field'+this.baseInfo.superiorField+'_value']
        let supDomId = "#tid_"+supId;
        tasks.forEach(item =>{
            if (item.id==supId && item.getAllChildren().length==0) {
              //清除父任务标识
              $(supDomId).attr('class',$(supDomId).attr('class').replace(/isParent/,''))
            }
        })

        //当前删除任务为已保存的任务
        API.deleteDatas({ ganttid:this.id,billid:this.currentDeleteId,type}).then(action(({ error, status,errorCode}) => {
            if (status == '1') {
                if(errorCode=='-1'){
                    message.error(error);
                }else{
                    message.success(getLabel(83472, "删除成功！"));
                    this.clear();
                    this.init();
                }
                this.deletevisible=false;
                this.loading=false;
            } else {
                message.error(error);
                throw error;
            }
        }));
    }

    //双击编辑行
    @action
    editTaskRow=(taskRow,task)=>{
        if(!task.canWrite)return;
        if(taskRow.attr('modify')=='1')return;//modify:1编辑状态
        const tds=taskRow.find("td");
        this.fields.forEach((item,index)=>{
            let td=tds[index+1];
            $(td).find('span').remove();
            let conditionType=ecCom.WeaInput;
            const fieldhtmltype=item.fieldhtmltype;
            let params :any={};
            const type=item.fieldtype;
            let detailtype='1';
            let reg:RegExp=new RegExp('');
            let otherParams={};
            if(fieldhtmltype=='1'){//单行文本
                if(type=='2'){//整数
                    reg=/^-?\d+$/;
                    detailtype='2';
                    otherParams={max:2147483647,min:-2147483648};
                }else if(type=='3'||type=='4'||type=='5'){//浮点数 金额转换 金额千分位
                    reg=/^(-?\d+)(.[0-9]{0,2})?$/;
                    switch(item.qfws){
                        case 1:reg=/^(-?\d+)(.[0-9]{0,1})?$/;break;
                        case 2:reg=/^(-?\d+)(.[0-9]{0,2})?$/;break;
                        case 3:reg=/^(-?\d+)(.[0-9]{0,3})?$/;break;
                        case 4:reg=/^(-?\d+)(.[0-9]{0,4})?$/;break;
                        case 5:reg=/^(-?\d+)(.[0-9]{0,5})?$/;break;
                        case 6:reg=/^(-?\d+)(.[0-9]{0,6})?$/;break;
                        case 7:reg=/^(-?\d+)(.[0-9]{0,7})?$/;break;
                        case 8:reg=/^(-?\d+)(.[0-9]{0,8})?$/;break;
                        case 9:reg=/^(-?\d+)(.[0-9]{0,9})?$/;break;
                        case 10:reg=/^(-?\d+)(.[0-9]{0,10})?$/;break;
                        case 11:reg=/^(-?\d+)(.[0-9]{0,11})?$/;break;
                        case 12:reg=/^(-?\d+)(.[0-9]{0,12})?$/;break;
                        case 13:reg=/^(-?\d+)(.[0-9]{0,13})?$/;break;
                        case 14:reg=/^(-?\d+)(.[0-9]{0,14})?$/;break;
                        case 15:reg=/^(-?\d+)(.[0-9]{0,15})?$/;break;
                    }
                    detailtype='2';
                    otherParams={max:999999999999.999999999999,min:-999999999999.999999999999};
                }
                params={detailtype,...otherParams,regExp:reg};
            }else if (fieldhtmltype == '5') {//选择框
                conditionType=ecCom.WeaSelect;
                params={options:this.optionsMap[item.fieldid],detailtype:type};
            }else if (fieldhtmltype == '3') {//浏览按钮
                if(type=='2'){
                    conditionType=ecCom.WeaDatePicker;
                }else if(type=='19'){
                    conditionType=ecCom.WeaTimePicker;
                }else if(type=='290'){
                    conditionType=ecCom.WeaDatePicker;
                    params={showTime:{format: "HH:mm"},format:"yyyy-MM-dd HH:mm"};
                }else if(type=='402'){
                    conditionType=ecCom.WeaDatePicker;
                    params={showTime:false,noinput:true,format:"YYYY"};
                }else if(type=='403'){
                    conditionType=ecCom.WeaDatePicker;
                    params={showTime:false,noinput:true,format:"YYYY-MM"};
                }else{
                    conditionType=ecCom.WeaBrowser;
                    if (type&&(type == '4' ||type == '57'||type == '164'  ||type == '169'||type == '194'|| type == '167'|| type == '170'|| type == '168')){   //部门，多部门，分部，多分部，单点分权，分权单部门，分权多分部，分权多部门
                        this.browserMap[item.fieldid].dataParams = {...this.browserMap[item.fieldid].dataParams,fromModule:"model" }
                        this.browserMap[item.fieldid].destDataParams  = {...this.browserMap[item.fieldid].dataParams,fromModule:"model" }
                    }

                    if (type == '256' || type == '257') {//	自定义树形单/多选
                        let urlParams = this.browserMap[item.fieldid].dataParams;
                        // let temp = {...urlParams, cube_treeid: urlParams.type + "_searchType" };
                        let temp = {...urlParams, cube_treeid: urlParams.type };
                        this.browserMap[item.fieldid].dataParams = temp;
                        this.browserMap[item.fieldid].destDataParams  = temp;
                    }

                    let value=task[item.fieldLink+"_value"] ? task[item.fieldLink+"_value"] : '';
                    let valueSpan=task[item.fieldLink] ? task[item.fieldLink] : '';
                    if(item.fieldLink.replace('field','')==this.baseInfo.superiorField&&value!=''){//如果是上级字段需要特殊处理下
                        valueSpan=this.ganttMaster.getTask(value).name;
                    }

                    interface browserItem {
                        id: string;
                        name: string;
                    }
                    let replaceDatas : browserItem[]= [];
                    let valArr = []
                    let valSpanArr :any = []
                    if (value && type == '141') {//人力资源条件
                        let values: any;
                        let names: any;
                        values = unSpellResourceCondition(value);
                        names = getDefaultValueSpan(valueSpan, values).split(/,|，/)
                        if (values.length == names.length) {
                            for (let i = 0;i < values.length;i++) {
                                let theName = names[i].replace(/  /g, ',');
                                valSpanArr.push(getReConditionObj(values[i], theName));
                            }
                        }
                        replaceDatas = valSpanArr;
                    } else if(value.trim()){
                        valArr = value.trim().split(',')
                        valSpanArr = valueSpan.trim().split(/,| /)
                        if (valArr.length === valSpanArr.length) {
                            valArr.forEach((element, i) => {
                                replaceDatas.push({ id: element, name: valSpanArr[i] })
                            });
                        }
                    }
                    params={...this.browserMap[item.fieldid], replaceDatas};
                }
            }else if (fieldhtmltype == '2') {//多行文本
                if(type=='1'){

                }else if(type == "2"){

                }
    
            }else if (fieldhtmltype == '4') {//Check框
                conditionType=ecCom.WeaCheckbox;
            }else{
                return;
            }
            let div=$("<div type='react' style='display: inline;'>");
            $(td).append(div);

            let eleValue = task[item.fieldLink+'_value']?task[item.fieldLink+'_value']:(task[item.fieldLink] ? task[item.fieldLink] : '')
            var ele=React.createElement(conditionType, {
                ...params,
                value: eleValue,
                noInput:true,
                viewAttr:'2',
                onChange: (value,valueSpan,temp)=>{
                    if (type == '141') { // 人力资源条件
                        let targetVal = spellResourceCondition(temp);
                        let targetValSpan = temp.map(item => {
                            if (item.sharetype == '5') {
                                return item.sharetypespan
                            } else {
                                let newName = `${item.sharetypespan}(${item.relatedsharespan})`
                                if (item.sharetype == '6') {
                                    newName = `${item.sharetypespan}(${item.relatedsharespan}/${item.joblevelspan}${item.jobfieldspan ? `(${item.jobfieldspan})` : ''})`
                                }
                                return newName
                            }
                        }).join(',');
                        value = targetVal;
                        valueSpan = targetValSpan;
                    }
                    
                    if(!valueSpan&&value){
                        valueSpan=value;
                    }
                    if(fieldhtmltype=='3'&&!task.hasOwnProperty(item.fieldLink+'_value')){
                        task[item.fieldLink+'_value']='';
                    }
                    var flag=this.synchronizeSVG(item,value,task);
                    if(flag){
                        task[item.fieldLink]=valueSpan;
                        if(task.hasOwnProperty(item.fieldLink+'_value')){
                            task[item.fieldLink+'_value']=value;
                            this.modifiedSup(td,value,task.id,item.fieldLink+'_value');
                        }else{
                            this.modifiedSup(td,value,task.id,item.fieldLink);
                        }
                    }else{
                        $(td).empty();
                        let div1=$("<div type='react' style='display: inline;'>");
                        $(td).append(div1);
                        ReactDOM.render(ele, div1[0]);
                    }
                },
                onBlur:(value,valueSpan)=>{
                    if(!valueSpan&&value){
                        valueSpan=value;
                    }
                    if(item.systemFlag=='1'){//如果修改的是标题字段则需要处理界面相关关联的地方
                        var superiorFieldTd=task.rowElement.find('td[fieldLink="field'+this.baseInfo.superiorField+'"]')[0];
                        var frontFieldTd=task.rowElement.find('td[fieldLink="field'+this.baseInfo.frontField+'"]')[0];
                        if(superiorFieldTd||frontFieldTd){
                            this.ganttMaster.tasks.forEach(element => {
                                if(element['field'+this.baseInfo.superiorField+'_value']==task.id){
                                    var current_superiorFieldTd=element.rowElement.find('td[fieldLink="field'+this.baseInfo.superiorField+'"]')[0];
                                    if(current_superiorFieldTd){
                                        $(current_superiorFieldTd).find('span')[0].innerText=valueSpan;
                                        element['field'+this.baseInfo.superiorField]=valueSpan;
                                    }
                                }
                                if(element['field'+this.baseInfo.frontField+'_value']==task.id){
                                    var current_frontFieldTd=element.rowElement.find('td[fieldLink="field'+this.baseInfo.frontField+'"]')[0];
                                    if(current_frontFieldTd){
                                        $(current_frontFieldTd).find('span')[0].innerText=valueSpan;
                                        element['field'+this.baseInfo.frontField]=valueSpan;
                                    }
                                }
                            });
                        }
                    }
                    //关于svg上的文字描述
                    if(item.fieldid==this.baseInfo.progressField||item.systemFlag=='1'&&task.ganttElement&&task.ganttElement.find('.taskLabelSVG')[0]){
                        task.ganttElement.find('.taskLabelSVG')[0].innerHTML=task.name+'('+(task['field'+this.baseInfo.progressField]||'0')+'%)';
                    }
                }
            });
            ReactDOM.render(ele, div[0]);
        });
        taskRow.attr('modify','1');
    }

    //添加被修改的状态
    modifiedSup=(td,value,id,fieldLink)=>{
        let task=this.ganttMaster.getTask(id);
        if(task){
            task[fieldLink]=value;
        }
        if(!this.datas[id]||value!=this.datas[id][fieldLink]){
            if($(td).find('sup').length==0){
                $(td).append($('<sup info="'+id+'_'+fieldLink+'"></sup>'));
            }
        }else{
            $(td).find('sup').remove();
        }
    }

    //空白处点击，取消table的编辑状态
    workSpaceClick=(e)=>{
        if(e&&e.originalEvent){
            if($("tr[modify='1']").length==0)return;
            const path=e.originalEvent.path;
            //是否执行
            let isCancelEdit=true;
            path.forEach(p => {
                if(p.nodeName=='TR'&&p.getAttribute('modify')=='1'){
                    isCancelEdit=false;
                }
            });
            if(isCancelEdit){
                this.cancelEditTaskRow();
            }
        }
    }

    @action
    afterInit=()=>{
        this.isInit=true;
    }

    //取消行的编辑状态
    @action
    cancelEditTaskRow=()=>{
        $("tr[modify='1']").each((index,item)=>{
            let task=this.ganttMaster.getTask(item.getAttribute('data-taskid'));
            const tds=$(item).find("td");
            this.fields.forEach((item,index)=>{
                let td=tds[index+1];
                $(td).find("div[type='react']").remove();
                let val=task[item.fieldLink] ? task[item.fieldLink] : '';
                if (item.fieldhtmltype=='3') { //浏览框
                    val = val.trim().split(',').join(' ');
                } else if (item.fieldhtmltype=='4') {//check框
                    if(val=='1'){
                        val='是';
                    }else if(val=='0'){
                        val='否';
                    }
                } else if (item.fieldhtmltype=='5') {//选择框
                    // let reg = /^[0-9]+.?[0-9]*$/;//数字正则
                    // if (reg.test(val)) {
                    //     val = this.optionsMap[item.fieldid][Number(val) + 1].showname || '';
                    // }else{
                    if (task.id.indexOf('tmp')==-1) {
                        val=task[item.fieldLink+'_value'] ? task[item.fieldLink+'_value'] : '';
                    }    
                    let ops = this.optionsMap[item.fieldid];
                    let newValArr : string[] = [];
                    val.split(",").forEach(element => {
                        let obj = _.find(ops, {'key': element}) as any;
                        obj && obj.showname && newValArr.push(obj.showname)
                    });
                    val = newValArr.join();
                    // }
                }
                // $(td).find("div[type='react']").remove();
                $(td).append($(`<span>${val}</span>`));
            });
            item.setAttribute('modify','0');
        });
    }


    @action
    showTaskInfo=(param)=>{
        if(this.ganttIsMouseDown){//如果是正在拖拽情况下
            return;
        }
        let task=param.task;
        if(task.id==this.taskInfo.id&&this.taskInfo.show){//若果已经打开状态就不用继续执行
            return;
        }
        var startp = new Date(task.start);
        // @ts-ignore
        startp = startp.format("yyyy-MM-dd HH:mm");
        var endp = new Date(task.end);
        // @ts-ignore
        endp =endp.format("yyyy-MM-dd HH:mm");
        let text1='计划日期:'+startp+' - '+endp;
        let text2='';
        if(task.hasActual){
          var astartp = new Date(task.actualbegindate);
          // @ts-ignore
          astartp = astartp.format("yyyy-MM-dd HH:mm");
          var aendp = new Date(task.actualenddate);
          // @ts-ignore
          aendp = aendp.format("yyyy-MM-dd HH:mm");
          text2='实际日期:'+astartp+' - '+aendp;
        }
        this.taskInfo={show:true,id:task.id,left:param.left-144+'px',top:param.top-65+'px',text1,text2};
    }

    @action
    closeTaskInfo=()=>{
        this.taskInfo.show=false;
    }

    @action
    update=(param:any)=>{
        for (let key in param) {
            if (key==='id') {
                this.previousId =  this.id;
            }
            this[key] = param[key]
        }
        // this.init();
    }

    @computed
    get getGanttId(){
        return this.id ;
    }

    /**
     * 添加任务元素（Item元素）
     */
    @action
    openDialog = (url,id?) => {
        this.cardDiag_visible = true;
        top.window['current_ganttStore'] = this;
        if(id){
            let url =getContentPath("/spa/cube/index.jsp#/main/cube/card?type=0&modeId="+this.baseInfo.modeid+"&formId="+this.baseInfo.formid+"&billid="+id);
            this.cardDiag_url = url;
        }else{
            this.cardDiag_url = url;
        }
        this.cardDiag_url+='&viewfrom=fromgantt';
        let reffield='';
        if(this.resourceId&&this.baseInfo.reffield){
            reffield='&field'+this.baseInfo.reffield+'='+this.resourceId;
        }
        this.cardDiag_url+=reffield;
        setTimeout(() => {
            document.getElementsByClassName('ant-modal')[0]['style'].top = '30px';
        }, 100);
    }


    //---------------------------------------------------------------------------------------------litterTool相关
    showLitterTool=(id,top)=>{
        if(!this.litterTool.show){
            const task=this.ganttMaster.getTask(id);
            if(this.canCreate||task.canRead){
                this.litterTool={show:true,id,top:top+'px',canRead:task.canRead,canWrite:task.canWrite,canDelete:task.canDelete};
            }
        }
    }

    closeLitterTool=()=>{
        this.litterTool.show=false;
    }


    //-----------------------------------------------------------------------------------------------同步右侧甘特图相关操作
    synchronizeSVG=(field,value,task)=>{
        if(field.fieldid==this.baseInfo.actualStartDateField){
            let orDate=this.getDateStr(task.actualbegindate);
            task.actualbegindate=new Date(value+" "+orDate.split(' ')[1]).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.actualStartTimeField){
            let orDate=this.getDateStr(task.actualbegindate);
            task.actualbegindate=new Date(orDate.split(' ')[0]+" "+value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.gttactualStartDateTimeField){
            task.actualbegindate=new Date(value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.actualEndDateField){
            let orDate=this.getDateStr(task.actualenddate);
            task.actualenddate=new Date(value+" "+orDate.split(' ')[1]).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.actualEndTimeField){
            let orDate=this.getDateStr(task.actualenddate);
            task.actualenddate=new Date(orDate.split(' ')[0]+" "+value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.gttactualEndDateTimeField){
            task.actualenddate=new Date(value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.startDateField){
            let orDate=this.getDateStr(task.start);
            task.start=new Date(value+" "+orDate.split(' ')[1]).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.startTimeField){
            let orDate=this.getDateStr(task.start);
            task.start=new Date(orDate.split(' ')[0]+" "+value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.gttstartDateTimeField){
            task.start=new Date(value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.endDateField){
            let orDate=this.getDateStr(task.end);
            task.end=new Date(value+" "+orDate.split(' ')[1]).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.endTimeField){
            let orDate=this.getDateStr(task.end);
            task.end=new Date(orDate.split(' ')[0]+" "+value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.gttendDateTimeField){
            task.end=new Date(value).getTime();
            this.ganttMaster.afterModifiedTask(task);
        }else if(field.fieldid==this.baseInfo.superiorField){//上级字段变更
            if(value==task.id){
                message.warn('不可用当前数据作为上级！');
                return false;
            }
            if(this.ganttMaster.getTask(task.id).getAllChildren().findIndex(item=>{return item.id==value})>-1){
                message.warn('不可用当前数据的下级作为上级！');
                return false;
            }
            task.depends=value;
            let parentTask=this.ganttMaster.getTask(value);
            let oldParentTask=task.getParent();
            if(parentTask){
                let parentTaskRow=parentTask.getRow();
                const difLevel=parentTask.level-task.level+1;
                //找到最下边一个子任务的index
                var row=task.getRow();
                var descNumber = 0;
                for (var i = row + 1; i < this.ganttMaster.tasks.length; i++) {
                  var desc = this.ganttMaster.tasks[i];
                  if (desc.level > task.level) {
                    descNumber++;
                    desc.level+=difLevel;
                    this.ganttMaster.editor.refreshTaskRow(desc);
                  } else {
                    break;
                  }
                }
                task.level+=difLevel;
                //移动editor
                var rows = this.ganttMaster.editor.element.find("tr[data-taskid]");
                parentTask.rowElement.after(rows.slice(row, row + descNumber + 1));
                var blockToMove = this.ganttMaster.tasks.splice(row, descNumber + 1);
                let topNum=parentTaskRow+1;
                if(row<parentTaskRow){//如果新上级在下边，top要减掉blockToMove的长度
                    topNum-=blockToMove.length;
                }
                var top = this.ganttMaster.tasks.splice(0,topNum);
                this.ganttMaster.tasks = [].concat(top, blockToMove, this.ganttMaster.tasks);
                this.ganttMaster.editor.refreshExpandStatus(parentTask);
                //移动gantt
                this.ganttMaster.gantt.moveGantt(row,row+descNumber,parentTaskRow);
            }else{//如果清除了上级，就将单条数据移到第一个去
                //找到最下边一个子任务的index
                var row=task.getRow();
                var descNumber = 0;
                for (var i = row + 1; i < this.ganttMaster.tasks.length; i++) {
                  var desc = this.ganttMaster.tasks[i];
                  if (desc.level > task.level) {
                    descNumber++;
                    desc.level+=descNumber;
                    this.ganttMaster.editor.refreshTaskRow(desc);
                  } else {
                    break;
                  }
                }
                task.level=0;
                //移动editor
                var rows = this.ganttMaster.editor.element.find("tr[data-taskid]");
                this.ganttMaster.tasks[0].rowElement.before(rows.slice(row, row + descNumber + 1));
                var blockToMove = this.ganttMaster.tasks.splice(row, descNumber + 1);
                this.ganttMaster.tasks = [].concat(blockToMove,this.ganttMaster.tasks);//将task放到最前面
                //移动gantt
                this.ganttMaster.gantt.moveGantt(row,row+descNumber,-1);
            }
            task.rowElement.click();
            this.ganttMaster.editor.refreshTaskRow(task);
            this.ganttMaster.editor.refreshExpandStatus(oldParentTask);
        }else if(field.fieldid==this.baseInfo.frontField){//前置字段变更
            if(value==task.id){
                message.warn('不可用当前数据作为前置关系！');
                return false;
            }
            task.front=value;
            var getGanttId = this.id;
            $(`.TWGanttWorkSpace_${getGanttId}`).find("g[to=" + task.id + "]").remove();
            //更新links
            this.ganttMaster.links=this.ganttMaster.links.filter(item=>item.to.id!=task.id);
            this.ganttMaster.links.push({from:value,to:task.id,lag:0});
            this.ganttMaster.gantt.drawLink(this.ganttMaster.getTask(value),task);
        }
        return true;
    }

    getDateStr=(d)=>{
        if(isNaN(d)){
            // @ts-ignore
            return new Date().format('yyyy-MM-dd HH:mm:ss');
        }
        // @ts-ignore
        return new Date(d).format('yyyy-MM-dd HH:mm:ss');
    }

    //svg变更同步左侧table数据  
    synchronizeGridEditor=(task,status)=>{
        let taskTr=$(`#workSpace_${this.getGanttId}`).find('tr[data-taskid="'+task.id+'"]');
        if(status=='jh'){//计划svg
            //处理开始日期
            if(this.baseInfo.startaloneOrcombination=='1'){//单独日期时间
                let startDateField=taskTr.find('td[fieldLink="field'+this.baseInfo.startDateField+'"]');
                let startTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.startTimeField+'"]');
                let st=this.getDateStr(task.start).split(' ');
                this.modifyTd(startDateField[0],st[0],this.baseInfo.startDateField,task);
                this.modifyTd(startTimeField[0],st[1].substring(0,5),this.baseInfo.startTimeField,task);
            }else{
                let startDateTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.gttstartDateTimeField+'"]');
                this.modifyTd(startDateTimeField[0],this.getDateStr(task.start),this.baseInfo.gttstartDateTimeField,task);
            }
            //处理结束日期
            if(this.baseInfo.endaloneOrcombination=='1'){
                let endDateField=taskTr.find('td[fieldLink="field'+this.baseInfo.endDateField+'"]');
                let endTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.endTimeField+'"]');
                let st=this.getDateStr(task.end).split(' ');
                this.modifyTd(endDateField[0],st[0],this.baseInfo.endDateField,task);
                this.modifyTd(endTimeField[0],st[1].substring(0,5),this.baseInfo.endTimeField,task);
            }else{
                let endDateTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.gttendDateTimeField+'"]');
                this.modifyTd(endDateTimeField[0],this.getDateStr(task.end),this.baseInfo.gttendDateTimeField,task);
            }
        }else if(status=='actual'){//实际svg
            //处理开始日期
            if(this.baseInfo.actualStartaloneOrcombination=='1'){
                let startDateField=taskTr.find('td[fieldLink="field'+this.baseInfo.actualStartDateField+'"]');
                let startTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.actualStartTimeField+'"]');
                let st=this.getDateStr(task.actualbegindate).split(' ');
                this.modifyTd(startDateField[0],st[0],this.baseInfo.actualStartDateField,task);
                this.modifyTd(startTimeField[0],st[1].substring(0,5),this.baseInfo.actualStartTimeField,task);
            }else{
                let startDateTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.gttactualStartDateTimeField+'"]');
                this.modifyTd(startDateTimeField[0],this.getDateStr(task.actualbegindate),this.baseInfo.gttactualStartDateTimeField,task);
            }
            //处理结束日期
            if(this.baseInfo.actualendaloneOrcombination=='1'){
                let endDateField=taskTr.find('td[fieldLink="field'+this.baseInfo.actualEndDateField+'"]');
                let endTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.actualEndTimeField+'"]');
                let st=this.getDateStr(task.actualenddate).split(' ');
                this.modifyTd(endDateField[0],st[0],this.baseInfo.actualEndDateField,task);
                this.modifyTd(endTimeField[0],st[1].substring(0,5),this.baseInfo.actualEndTimeField,task);
            }else{
                let endDateTimeField=taskTr.find('td[fieldLink="field'+this.baseInfo.gttactualEndDateTimeField+'"]');
                this.modifyTd(endDateTimeField[0],this.getDateStr(task.actualenddate),this.baseInfo.gttactualEndDateTimeField,task);
            }
        }
    }

    //修改svg前置关系后同步grid
    synchronizeGridEditorFront=(taskFrom,taskTo)=>{
        let taskTr=$(`#workSpace_${this.getGanttId}`).find('tr[data-taskid="'+taskTo.id+'"]');
        let frontField=taskTr.find('td[fieldLink="field'+this.baseInfo.frontField+'"]');
        this.modifyTd(frontField[0],taskFrom.id,this.baseInfo.frontField,taskTo,taskFrom.name);
        this.modifiedSup(frontField[0],taskFrom.id,taskTo.id,'field'+this.baseInfo.frontField+'_value');
    }

    //修改字段值,记录svg修改的值
    modifyTd=(td,value,fieldid,task,valueSpan='')=>{
        var innerText=value;
        var fieldLink='field'+fieldid;
        if(td){
            if(task.hasOwnProperty('field'+fieldid+'_value')){
                task[fieldLink+'_value']=value;
                task['field'+fieldid]=valueSpan;
                innerText=valueSpan;
                this.modifiedSup(td,value,task.id,'field'+fieldid+'_value');
            }else{
                task[fieldLink]=value;
                this.modifiedSup(td,value,task.id,'field'+fieldid);
            }
            $(td).find('span')[0].innerText=innerText;
        }else{
            if(task.hasOwnProperty('field'+fieldid+'_value')){//浏览框字段
                fieldLink=fieldLink+'_value';
            }
            if(!this.datas[task.id]||value!=this.datas[task.id][fieldLink]){
                this.otherModifiedDatas[task.id+'_field'+fieldid]=value;
            }else{
                delete this.otherModifiedDatas[task.id+'_field'+fieldid];
            }
        }
    }

    delHtmlTag(str){//去掉所有的html标记
		return str.replace(/<[^>]+>/g,"");
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/gantt/GanttStore.tsx